<template>

  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">参数设置</div>
      <el-form-item label="是否开启分享：">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发布分享得 " prop="release_points" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入积分" type="number" min="0" v-model="form.release_points" class="max-w460">
          <template slot="append">积分</template>
        </el-input>
        <div class="red">后台审核通过后奖励</div>
      </el-form-item>
      <el-form-item label="每天最多可发布 " prop="release_day_limit" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入次数" type="number" min="0" v-model="form.release_day_limit" class="max-w460">
          <template slot="append">次分享</template>
        </el-input>
        <div class="red">设置为0不限制发布次数</div>
      </el-form-item>
      <el-form-item label="转发分享得 " prop="share_points" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入积分" type="number" min="0" v-model="form.share_points" class="max-w460">
          <template slot="append">积分</template>
        </el-input>
      </el-form-item>
      <el-form-item label="每天最多可得 " prop="share_day_limit" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入次数" type="number" min="0" v-model="form.share_day_limit" class="max-w460">
          <template slot="append">次转发积分</template>
        </el-input>
      </el-form-item>

      <div class="common-form">规则</div>
      <el-form-item label="内容" v-if="!loading">
        <div class="edit_container">
          <Uediter v-model="form.content" id="ue" :text="form.content" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>
<script>
  import DiaryApi from '@/api/diary.js';
  import Uediter from '@/components/UE.vue';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{
      Uediter
    },
    data() {
      return {
        is_linkset:false,
        isUpload:false,
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,//省区域奖励
          content: '',
          release_points: '',
          release_day_limit: '',
          share_points: '',
          share_day_limit: '',
        },
        /*富文本配置*/
        ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        }
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        DiaryApi.setDetail({}, true).then(res => {
            let setting = res.data.setting;
            self.form = formatModel(self.form, setting);
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });

      },


      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        
        params.content = this.$refs.ue.getUEContent();

        self.loading = true;
        console.log(params);
        DiaryApi.editSet(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '设置成功',
              type: 'success'
            });
            self.$router.push('/diary/setting/index');
          })
          .catch(error => {
            self.loading = false;
          });
      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
  .draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/diary/setting/index.vue